"use strict";

/**
 * Базовый виджет для виджетов, поведение которых основано на изменении значения dropdown элемента
 *
 * Цель: избавить конкретные виджеты, наследующие этот, от необходимости знать что-либо о стилизации
 *       элемента, а также изменение с задержкой (для случая перебора значений селекта клавиатурой)
 */
$.widget("fotobook.dropdownbasewidget", {
    "options" : {
        "changeDelay": 500,
    },

    _create: function(){
        this._on(this.widget(), {
            "change" : this.changeTimeout,
        });
    },
    _setOptionDisabled: function(value){
        this._super();
        this.widget().prop("disabled", !!value);
    },
    value: function(value){
        if (value === undefined){
            return this.widget().val();
        }
        return this;
    },

    change(){
        return Promise.resolve();
    },
    _changeInternal(){
        this.disable();
        this.change(
            this.widget().val()
        ).catch(
            () => {}
        ).finally(() => this.enable());
    },
    _changeTimeout: null,
    /**
     * Вызываем change с задержкой, чтобы можно было перебирать варианты клавиатурой
     */
    changeTimeout: function(event){
        var widget = this;

        if (!this.changeTimeout){
            this._changeInternal();
            return;
        }

        if (this._changeTimeout) {
            clearTimeout(this._changeTimeout);
        }
        this._changeTimeout = setTimeout(function(){
            widget._changeTimeout = null;
            widget._changeInternal();
        }, this.options.changeDelay);
    },
    _destroy: function(){
        this._super();
        if (this._changeTimeout){
            clearTimeout(this._changeTimeout);
            this._changeTimeout = null;
        }
    },
});
